import React from 'react';
import { Container } from 'react-bootstrap';
import CriarUsuarioInterno from '../criar_usuario_interno';

const UsuariosCadastro = () => {
  // useEffect(() => {
  //   setFocus('nome')
  //   if (params.id) {
  //     setLoading(true)
  //     Contas.listId(params.id)
  //       .then((data) => {
  //         setValue('nome', data.data.nome);
  //         setValue('ativo', data.data.ativo);
  //         setValue('saldo', formatMoney(data.data.saldo));
  //       })
  //       .catch((error) => {
  //         SweetAlert.error(error.response.data.message, 'Conta');
  //       })
  //       .finally(() => { setLoading(false) })

  //   } else {
  //     setValue('saldo', 'R$ 0,00')
  //   }
  // }, []);

  return (
    <>
      {/* {loading === true ? <Loading /> : ''} */}
      <Container>
        <CriarUsuarioInterno />
      </Container>
    </>
  );
}

export default UsuariosCadastro;
